module.exports = __webpack_public_path__ + "img/adminServiceInfo2.17ac21f6.png";